class GzToast extends HTMLElement {
  connectedCallback() {
    this.cacheElements();
    this.attachListeners();
    this.loadFromAttributes();
  }

  /**
   * Cache DOM elements
   */
  cacheElements() {
    this.closeButton = this.querySelector('[data-toast-close]');
    this.titleElement = this.querySelector('[data-toast-title]');
    this.messageElement = this.querySelector('[data-toast-message]');
  }

  /**
   * Attach event listeners
   */
  attachListeners() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (e) => {
        // Prevent event from bubbling up to form or other elements
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Close toast
        this.hide();
      });
    }
  }

  /**
   * Load initial content from data attributes
   */
  loadFromAttributes() {
    const type = this.getAttribute('data-type');
    const title = this.getAttribute('data-title');
    const message = this.getAttribute('data-message');

    if (title && this.titleElement) {
      this.titleElement.textContent = title;
    }

    if (message && this.messageElement) {
      this.messageElement.textContent = message;
    }
  }

  /**
   * Update toast content
   */
  update({ type, title, message } = {}) {
    // Update type class
    if (type) {
      this.classList.remove('gz-toast--success', 'gz-toast--warning', 'gz-toast--danger');
      this.classList.add(`gz-toast--${type}`);
      this.setAttribute('data-type', type);
    }

    // Update title
    if (title && this.titleElement) {
      this.titleElement.textContent = title;
      this.setAttribute('data-title', title);
    }

    // Update message - use innerHTML to render HTML tags
    if (message !== undefined && this.messageElement) {
      this.messageElement.innerHTML = message; // Changed from textContent
      this.messageElement.style.display = message ? '' : 'none';
      if (message) {
        this.setAttribute('data-message', message);
      } else {
        this.removeAttribute('data-message');
      }
    }
  }

  /**
   * Show toast
   */
  show() {
    this.classList.add('show');
  }

  /**
   * Hide toast
   */
  hide() {
    this.classList.remove('show');
  }

  /**
   * Toggle toast
   */
  toggle() {
    this.classList.toggle('show');
  }
}

customElements.define('gz-toast', GzToast);